import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { VerificationType } from '@/modules/user/components/Verification/verification.types';

import { useGetVerificationEmail } from '../hooks';

const useEmailValidationQuery = () => {
  const email = useGetVerificationEmail();
  const {
    mutateAsync: handleReceiveCode,
    isLoading: isReceiveCodeLoading,
    isError: isReceiveCodeError,
  } = useMutation(() =>
    api.post(API_URL.CODES_VERIFICATIONS, {
      value: email,
      type: VerificationType.EMAIL,
    })
  );

  return {
    handleReceiveCode,
    isLoading: isReceiveCodeLoading,
    isError: isReceiveCodeError,
  };
};

export default useEmailValidationQuery;
